module.exports = __webpack_public_path__ + "static/media/tasks.3ef3a109.jpg";